import qs from 'qs';

/**
 *
 * @param {URLSearchParams} searchParams
 * @returns {Object.<string, (string|string[])>}
 */
export const searchParamsFormatter = (searchParams) => {
  const nextQuery = {};

  if (searchParams) {
    const paramsMap = new Map();
    searchParams.forEach((value, key) => {
      const matches = key.match(/([A-Za-z0-9_-]+)(\[([0-9][1-9]*)?\])?/);
      let name = key;
      let arrayIndex = null;
      let isArray = false;
      if (matches && matches.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        name = matches[1];
        if (matches?.[2]) {
          isArray = true;
        }
        if (matches?.[3]) {
          arrayIndex = parseInt(matches[3], 10);
        }
      }
      const nextItem = {
        value,
        index: arrayIndex,
        isArray,
      };
      const prevItem = paramsMap.get(name);
      if (!prevItem) {
        paramsMap.set(name, [nextItem]);
      } else {
        paramsMap.set(name, [...prevItem, { ...nextItem, isArray: true }]);
      }
    });
    paramsMap.forEach((value, key) => {
      value.sort((a, b) => {
        if (a.index === b.index) return 0;
        if (a.index === null) return 1;
        if (b.index === null) return -1;

        return a.index - b.index;
      });
      nextQuery[key] = value.reduce(
        (accu, valueItem) => (valueItem.isArray ? true : accu),
        false,
      )
        ? value.map((valueItem) => valueItem.value)
        : value[0].value;
    });
  }

  return nextQuery;
};

/**
 * @param {string} param
 * @param {URLSearchParams} searchParams
 * @returns {null|string}
 */
export const getSearchParam = (param, searchParams) => {
  const formattedSearchParams = searchParamsFormatter(searchParams);
  if (formattedSearchParams[param]) {
    return formattedSearchParams[param];
  }

  return null;
};

/**
 * @param {string[]} params
 * @param {URLSearchParams} searchParams
 * @returns {Object.<string, (string|string[])>}
 */
export const getSearchParams = (params, searchParams) =>
  params.reduce(
    (accu, param) => ({
      ...accu,
      [param]: getSearchParam(param, searchParams),
    }),
    {},
  );

/**
 *
 * @param {Object.<string, (string|string[]|number|number[])>} query
 * @param {URLSearchParams} searchParams
 * @param {boolean} keepPrevious
 * @returns {string}
 */
export const getNextUrlQuery = (query, searchParams, keepPrevious = true) => {
  const formattedSearchParams = searchParamsFormatter(searchParams);
  const nextQuery = keepPrevious ? { ...formattedSearchParams } : {};
  Object.keys(query).forEach((param) => {
    const value = query[param];
    if (value === null) {
      delete nextQuery[param];
    } else if (Array.isArray(value)) {
      nextQuery[param] = value.map((v) => `${v}`);
    } else {
      nextQuery[param] = `${value}`;
    }
  });

  let urlQuery = '';
  if (Object.keys(nextQuery).length > 0) {
    urlQuery = qs.stringify(nextQuery, {
      addQueryPrefix: true,
      arrayFormat: 'brackets',
    });
  }

  return urlQuery;
};
